import { useCallback } from 'react';
import { QueryFunctionContext } from '@tanstack/react-query';
import { useClientProviderFetcher } from '../../../../../hooks/useClientProviderFetcher';

const useClientsFetcher = (basePath: string) => {
  const { fetchQueryClients } = useClientProviderFetcher(basePath);

  return useCallback(
    async ({ queryKey, pageParam = 0 }: QueryFunctionContext) => {
      const [, limit, query] = queryKey as [string, number, string];
      const clients = await fetchQueryClients(query, limit, pageParam);
      if (clients) {
        return clients;
      } else {
        throw new Error('No clients available for your account');
      }
    },
    [fetch],
  );
};

export default useClientsFetcher;
